export default __webpack_public_path__ + "static/media/szafy8.b2df39d6.jpg";